import { useEffect, useState } from "react";
import "./App.css";
import PeethaCard from "./components/PeethaCard";
import PeethaDetail from "./components/PeethaDetail";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { fetchPeethas } from "./api/peethas";

function App() {
  const [peethas, setPeethas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPeethas()
      .then(setPeethas)
      .catch(() =>
        setError("Unable to load Shakti Peeths right now. Please try again later.")
      )
      .finally(() => setLoading(false));
  }, []);

  return (
    <Router>
      <Routes>
        {/* Home Page */}
        <Route
          path="/"
          element={
            <>
              {/* Sacred Frame */}
              <div className="sacred-frame">
                <div className="corner top-left">◈</div>
                <div className="corner top-right">◈</div>
                <div className="corner bottom-left">◈</div>
                <div className="corner bottom-right">◈</div>
              </div>

              {/* Main Content */}
              <div className="relative z-10 max-w-7xl mx-auto px-6 pt-4 pb-10 min-h-screen">
                <header className="text-center mb-10">
                  <div className="flex justify-center">
                    <img
                      src="/assets/Devimaaa.png"
                      alt="Shakti Pravaah Devi Logo"
                      className="w-40 h-40 object-contain"
                    />
                  </div>

                 <h1 className="text-6xl font-serif font-bold text-orange-800 -mt-2">
  Shakti Pravaah
</h1>

<h2 className="text-xl text-orange-600 font-medium mt-1">
  Explore the Sacred 51 Shakti Peeths of Bharat
</h2>
                </header>

                {loading && (
                  <p className="text-center text-orange-700">
                    Loading Shakti Peeths...
                  </p>
                )}

                {error && (
                  <p className="text-center text-red-500">{error}</p>
                )}

                {!loading && !error && (
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
                    {peethas.map((peetha) => (
                      <Link
                        key={peetha.slug}
                        to={`/peetha/${peetha.slug}`}
                        className="block"
                      >
                        <PeethaCard {...peetha} />
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            </>
          }
        />

        {/* Detail Page */}
        <Route
  path="/peetha/:slug"
  element={
    loading ? (
      <p className="text-center text-orange-700 mt-10">Loading...</p>
    ) : (
      <PeethaDetail peethas={peethas} />
    )
  }
/>
      </Routes>
      <footer className="bg-[#8B4513] text-white py-6 mt-12">
  <div className="max-w-7xl mx-auto px-4 text-center">
    <p className="text-sm md:text-base">
      © {new Date().getFullYear()} Shakti Pravaah. All Rights Reserved.
    </p>

    <p className="text-xs mt-2 opacity-80">
      A spiritual journey through the sacred 51 Shakti Peethas of Bharat.
    </p>
  </div>
</footer>
    </Router>
    
  );
}

export default App;